import apiClient from './api-client';

const horariosService = {
    listar: async () => {
        try {
          const response = await apiClient.get('/horarios');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      obter: async (id) => {
        try {
          const response = await apiClient.get('/horarios/:id');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      disponiveis: async (salaId, data) => {
        try {
          const response = await apiClient.get('/horarios/disponiveis', 
            {
              params:{
                salaId,
                data
              }
            });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
}

export default horariosService;